export default "__VITE_ASSET__BFCeuwNB__"